(function ($, $$) {
	return
	document.readyState == "interactive" || document.readyState == "complete"
		? initialize()
		: window.addEventListener("load", initialize);

	function initialize() {
		const tagList = initializeTags()
		const query = $('idb-query[type="list"]')
		const pagination = $$('pagination-control')
		window.addEventListener("item-click", setActiveItem);
		window.addEventListener("page-change", changePage);
		query?.addEventListener('filter-update', updateTagList)
		pagination.forEach(_ => _.addEventListener('page-change', this.changePage))
		function changePage({ detail }) {
			const pageSize = query.limit;
			const offset = (detail.nextPage - 1) * pageSize;
			query.setAttribute("offset", offset);
			Array.from($$("pagination-control")).forEach((_) =>
				_.setAttribute("current", detail.nextPage),
			);
		}

		function setActiveItem(event) {
			const item = event.detail.item;
			if (!item || Array.isArray(item)) return;
			Array.from($$("entity-provider")).forEach(
				(input) => (input.value = item),
			);
		}
		function initializeTags() {
			const tagList = $$("tag-list");
			tagList.forEach((_) =>
				_.addEventListener("tag-removed", syncQueryFilter),
			);
			return tagList;
		}

		function syncQueryFilter(event) {
			const {
				detail: {
					removed: { key, value },
				},
			} = event;
			const node = this.htmlFor.querySelector(`[name="filter.${key}"]`);
			const query = $('idb-query[type="list"]');
			node.removeValue?.(value);
			if (node.tagName == "VAADIN-TEXT-FIELD") node.value = "";
			query?.handleData();
		}

		function updateTagList(event) {
			tagList.forEach(
				(_) =>
					(_.selectedItems = event.target.filters.filter(([_, __, tag]) =>
						tag.match(/indexed-db-filter/i)
				))
			)
		}
	}
})(
	document.querySelector.bind(document),
	document.querySelectorAll.bind(document),
);
